var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50054 2.03564C4.13563 2.03564 1.3999 4.71018 1.3999 8.00018C1.3999 11.2902 4.13618 13.9647 7.50054 13.9647C10.8654 13.9647 13.6006 11.2902 13.6006 8.00018C13.6006 4.71018 10.8653 2.03564 7.50054 2.03564ZM7.50054 2.7372C10.4776 2.7372 12.8832 5.08934 12.8832 8.00027C12.8832 10.9112 10.4776 13.2633 7.50054 13.2633C4.52345 13.2633 2.11786 10.9112 2.11786 8.00027C2.11786 5.08934 4.52345 2.7372 7.50054 2.7372ZM7.48562 5.06227C7.19319 5.06956 6.95562 5.30654 6.95562 5.59404C6.95562 5.88623 7.20065 6.12738 7.49948 6.12738C7.79831 6.12738 8.04387 5.88675 8.04387 5.59404C8.04387 5.30186 7.79831 5.06227 7.49948 5.06227H7.48562ZM7.50054 6.568C7.40466 6.56748 7.31304 6.60446 7.24539 6.67061C7.17774 6.73675 7.13992 6.82686 7.13992 6.92009V10.5852C7.13992 10.6784 7.17774 10.7685 7.24539 10.8346C7.31304 10.9008 7.40466 10.9378 7.50054 10.9372C7.59535 10.9367 7.68644 10.8997 7.75356 10.8336C7.82068 10.7674 7.85796 10.6784 7.85796 10.5852V6.92009C7.85796 6.82738 7.82068 6.73779 7.75356 6.67165C7.68645 6.6055 7.59535 6.56852 7.50054 6.568Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.3a55235769aa4a55285d0a3373715a4f.svg";
export { ForwardRef as ReactComponent };